import { Loader2 } from 'lucide-react';
import { tx } from '../i18n';

interface SpinnerProps {
  label?: string;
  size?: number;
}

/** Accessible busy indicator; the label is announced rather than hidden. */
export default function Spinner({ label, size = 18 }: SpinnerProps) {
  const text = label ?? tx('Working', 'İşleniyor',
    'Pracuję',
    'A trabalhar',
    'Trabajando');
  return (
    <span className="spinner" role="status">
      <Loader2 size={size} aria-hidden="true" />
      {text}
    </span>
  );
}
